//import axiosLoadingIndicatorFactory from '../axios-loading-indicator';
import axios from 'axios';
import handlers from './default-handlers';

export default {
    search(vue, searchString, cancelToken, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.company.search, {
            q: searchString,
        }, {
            cancelToken: cancelToken,
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    getDetails(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.company.details).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    getCompetitions(vue, cb, errorCb, finallyCb, parameters) {
        axios.get(window.kgkRoutes.company.getCompetitions + parameters).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    updateCreateCompetitions(vue, parameters, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.company.updateCreateCompetitions, parameters, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    inviteLinks(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.company.inviteLinks).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    generateInviteLink(vue, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.company.inviteLink, {}).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
}
